import { useAdsTargeting } from '@folklore/ads';
import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import isEmpty from 'lodash-es/isEmpty';

import * as DocumentCards from '../cards/documents';

import styles from '../../styles/ads/document-card-ad.module.css';

interface DocumentCardAdProps {
    title?: string;
    image?: string;
    surtitle?: string;
    author?: string;
    clickUrl?: string;
    className?: string;
}

function DocumentCardAd({
    title,
    surtitle,
    image,
    author,
    clickUrl,
    className,
}: DocumentCardAdProps) {
    const {
        cardType = 'vertical',
        cardTheme = 'box-translucent',
        cardRatio = 'horizontal',
        cardSize,
        inCard = false,
    } = useAdsTargeting();
    const DocumentCard = getComponentFromName(DocumentCards, cardType as string, 'vertical');
    return (
        <DocumentCard
            type="native_ad"
            title={title}
            externalUrl={clickUrl}
            surtitle={!isEmpty(surtitle) ? surtitle : undefined}
            credits={
                !isEmpty(author)
                    ? ([
                          {
                              author: {
                                  name: author,
                              },
                          },
                      ] as Credit[])
                    : undefined
            }
            image={
                !isEmpty(image)
                    ? ({
                          url: image,
                      } as Image)
                    : undefined
            }
            theme={cardTheme}
            ratio={cardRatio}
            size={cardSize}
            withoutAdNotice={!inCard}
            className={classNames(
                styles.container,
                {
                    [styles.withMaxWidth]: !inCard,
                },
                className,
            )}
        />
    );
}

export default DocumentCardAd;
